import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getLeague } from "../../api/getLeague";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../component/users/Header";
import LoaderLayout from "../../component/users/LoaderLayout";
import LoaderLayout2 from "../../component/users/LoaderLayout2";
import Footer from "../../component/users/Footer";
import { Box, Button, Container } from "@mui/material";
import ViewTournamentComponent from "../../component/users/ViewLeague/Index";

const ViewTournament = () => {
  const { id } = useParams();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.user.loading);

  const [loading, setloading] = useState(true);

  const [tournament, setTournament] = useState(null);

  const fetchTournament = async (id, token) => {
    try {
      const data = await getLeague(id, token);
      if (data.success) {
        setTournament(data?.data);
      } else {
        toast.error(data.message);
        // throw Error(data.message);
        // Navigate("/");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchTournament(id, token);
    } else {
      setloading(false);
      toast.error("Goal ID is missing");
    }
  }, [id]);

  return (
    <>
      <Header />

      {user ? (
        <LoaderLayout />
      ) : !loading ? (
        <Box className="userLayout addGoal">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743" }}
          >
            <Box className="leader-board-main">
              <Box className="leader-board-wrapper">
                <ViewTournamentComponent
                  club={tournament}
                  setClub={setTournament}
                />
              </Box>
            </Box>
          </Container>
          <Footer />
        </Box>
      ) : (
        <LoaderLayout2 />
      )}
    </>
  );
};

export default ViewTournament;
